module.exports = __webpack_public_path__ + "static/media/swim.283604a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swim.jpg
// module id = 5748
// module chunks = 0